import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { NotificationType } from '../../constants/NotificationType';

function NotificationTypeSection({ title, emailSettings, pushSettings, onChangeConfig }) {
  return (
    <div>
      <h4 className="text-center font-weight-bold mb-3">{title}</h4>
      <Row>
        <Col xs="12" md="6">
          <Form>
            <FormGroup className="d-flex flex-column align-items-start gap-3">
              <Label for="email">EMAIL</Label>
              {emailSettings?.map((item) => (
                <Label check key={`${item.event}email`} className="d-flex gap-1">
                  <Input
                    key={`${item.event}email`}
                    type="switch"
                    checked={item.checked}
                    onChange={() => onChangeConfig(NotificationType.EMAIL, item.event)}
                    id={`${item.eventMessage}email`}
                  />
                  {item.eventMessage}
                </Label>
              ))}
            </FormGroup>
          </Form>
        </Col>
        <Col xs="12" md="6">
          <Form>
            <FormGroup className="d-flex flex-column align-items-start gap-3">
              <Label for="push">PUSH</Label>
              {pushSettings?.map((item) => (
                <Label check key={`${item.event}push`} className="d-flex gap-1">
                  <Input
                    type="switch"
                    checked={item.checked}
                    onChange={() => onChangeConfig(NotificationType.PUSH, item.event)}
                    id={`${item.eventMessage}push`}
                  />
                  {item.eventMessage}
                </Label>
              ))}
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </div>
  );
}
NotificationTypeSection.defaultProps = {
  emailSettings: [],
  pushSettings: [],
};

NotificationTypeSection.propTypes = {
  title: PropTypes.string.isRequired,
  emailSettings: PropTypes.array,
  pushSettings: PropTypes.array,
  onChangeConfig: PropTypes.func.isRequired,
};

export default NotificationTypeSection;
